// extracted by mini-css-extract-plugin
export var logo = "_b9-2";
export var logoWrapper = "_b9-1";
export var strip = "_b9-0";